export function getPickableLineItems<T extends { quantity: number; fulfillable_quantity?: number }>(
  items: T[]
): T[] {
  return items
    .map((item) => {
      const remaining = item.fulfillable_quantity ?? item.quantity
      return { ...item, quantity: remaining }
    })
    .filter((item) => item.quantity > 0)
}

export function getPickableUnitCount(items: Array<{ quantity: number; fulfillable_quantity?: number }>): number {
  return getPickableLineItems(items).reduce((sum, item) => sum + item.quantity, 0)
}

export function getPickableLineCount(items: Array<{ quantity: number; fulfillable_quantity?: number }>): number {
  return getPickableLineItems(items).length
}
